// utils/url.js

/**
 * Build a URL path with a safely encoded query string.
 * - Encodes keys/values with encodeURIComponent (spaces -> %20)
 * - Skips null/undefined
 * - Repeats keys for arrays: roles=admin&roles=editor
 */
export function uriWithQueryStringParams(path, params) {
  if (!params || typeof params !== "object") {
    return path;
  }

  const parts = [];
  for (const [key, value] of Object.entries(params)) {
    if (value == null) {
      continue; // skip null/undefined
    }

    if (Array.isArray(value)) {
      for (const v of value) {
        if (v == null) {
          continue;
        }
        parts.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`
        );
      }
    } else {
      parts.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
      );
    }
  }

  return parts.length ? `${path}?${parts.join("&")}` : path;
}
